import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { ROUTES } from '#/config/routes';
import { fetchInspectionKindRevision } from '#/api/imsMgmt/settings/inspectionKind/fetchRevision';
import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';
import PageShell from '#/modules/infra/layout/PageShell';
import InspectionKindReadonly from '#/modules/imsMgmt/settings/inspectionKind/components/InspectionKindReadonly';
import { getInspectionKindApiErrorMessage } from '#/modules/imsMgmt/settings/inspectionKind/helper/apiError';
import { inspectionKindRevisionQueryKey } from '#/utils/queryKeys';

const InspectionKindRevisionPage = () => {
  const { id, revisionNo } = useParams();
  const revisionQuery = useQuery({
    queryKey: inspectionKindRevisionQueryKey(id, revisionNo),
    queryFn: () => fetchInspectionKindRevision(id, revisionNo),
    enabled: Boolean(id && revisionNo),
  });
  const detail = revisionQuery.data?.data;

  return (
    <PageShell variant="detail">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div className={cn('flex flex-wrap items-center justify-between gap-2')}>
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">
                {`歷史版本 ${revisionNo}`}
              </span>
            </h1>
            <div className="flex flex-wrap gap-2">
              <Button type="button" variant="outline" asChild>
                <Link to={ROUTES.inspectionKindDetail(id)}>返回目前版本</Link>
              </Button>
              <Button type="button" variant="outline" asChild>
                <Link to={ROUTES.inspectionKind}>返回列表</Link>
              </Button>
            </div>
          </div>

          {revisionQuery.isLoading ? (
            <p className="text-sm text-muted-foreground">載入中…</p>
          ) : revisionQuery.isError ? (
            <p className="text-sm text-destructive">
              {getInspectionKindApiErrorMessage(revisionQuery.error, '找不到這個歷史版本')}
            </p>
          ) : (
            <InspectionKindReadonly
              detail={detail}
              note="這是歷史版本，只能查看，不能存回。"
            />
          )}
        </div>
      </div>
    </PageShell>
  );
};

export default InspectionKindRevisionPage;
